<div class="search-group">
  <fuse-opinion-filter></fuse-opinion-filter>
  <fuse-driver-filter></fuse-driver-filter>
  <fuse-order-type-filter></fuse-order-type-filter>
</div>
